import { Box, Typography } from '@mui/material';
import { ColorScheme } from '../../Themes/ColorScheme';
import { Spinner } from './Spinner';

const SmallButton = ({ text, activity, borderColor, backgroundColor, textColor, action }) => (

        <Box
            sx={{
                border: "1px solid " + (borderColor ? borderColor : ColorScheme.secondary),
                backgroundColor: backgroundColor ? backgroundColor : "transparent",
                height: "30px",
                width: "150px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "transform 0.2s ease-in-out",
                '&:hover': {
                    transform: "scale(1.02)"
                }
            }}
            onClick={action}
        >
            {activity ? (
                <Spinner color={backgroundColor == ColorScheme.secondary ? ColorScheme.primary : ColorScheme.secondary} />
            ) : (
                <Typography sx={{ fontSize: "12px", color: textColor ? textColor : ColorScheme.secondary }}>
                {text}
                </Typography>
            )}
        </Box>
    );


export default SmallButton;